import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type DomicileDto, getAllDomiciles } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useDomiciles(): UseQueryResult<DomicileDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.domiciles(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getAllDomiciles({ signal }).then((result) => result.data),
    });
}
